import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DocListState {
  docCurrentPage: number;
  docPageSize: number;
  docSearchKeyword: string;
  updateDocCurrentPage: (value: number) => void;
  updateDocPageSize: (value: number) => void;
  updateDocSearchKeyword: (value: string) => void;
  resetDocSearchKeyword: () => void;
  getDocCurrentPage: () => number;
  getDocPageSize: () => number;
}

export const useDocListStore = create<DocListState>()(
  persist(
    (set, get) => ({
      docCurrentPage: 1,
      docPageSize: 10,
      docSearchKeyword: "",

      updateDocCurrentPage: (value: number) => {
        set({ docCurrentPage: value });
      },

      updateDocPageSize: (value: number) => {
        set({ docPageSize: value });
      },

      updateDocSearchKeyword: (value: string) => {
        set({ docSearchKeyword: value });
      },

      resetDocSearchKeyword: () => {
        set({ docSearchKeyword: "" });
      },

      getDocCurrentPage: () => get().docCurrentPage,
      getDocPageSize: () => get().docPageSize,
    }),
    {
      name: "docList-storage",
      partialize: state => ({
        docCurrentPage: state.docCurrentPage,
        docPageSize: state.docPageSize,
        docSearchKeyword: state.docSearchKeyword,
      }),
    }
  )
);
